var _style, _path, _polyline, _polyline2, _polyline3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _polyline4, _polyline5, _polyline6, _path2, _path3, _path4, _path5, _path6, _path7, _polyline7, _polyline8, _polyline9, _path8, _path9, _path10, _path11, _path12, _path13, _polyline10, _polyline11, _polyline12, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 402 232.5",
    style: {
      enableBackground: "new 0 0 402 232.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#859CA7;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#859CA7;stroke-width:4.5715;stroke-miterlimit:10;}\r\n\t.st3{fill:#287DC0;}\r\n\t.st4{fill:none;stroke:#859CA7;stroke-width:3.2;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#859CA7;stroke-width:3.6572;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#859CA7;stroke-width:2.16;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#859CA7;stroke-width:2.4686;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#859CA7;stroke-width:1.62;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#859CA7;stroke-width:1.8514;stroke-miterlimit:10;}\r\n\t.st10{fill:none;stroke:#297BBF;stroke-width:14;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M388.4,163.8c0-31.3-25.4-56.7-56.7-56.7c-4.4,0-8.6,0.5-12.7,1.4c0.7-3.9,1.2-7.9,1.2-12 c0-35.1-28.4-63.5-63.5-63.5c-18.8,0-35.6,8.1-47.2,21.1c-12.2-25.9-38.5-43.8-69-43.8c-42.1,0-76.2,34.1-76.2,76.2 c0,7.2,1,14.1,2.9,20.7c-29.5,2-52.9,26.5-52.9,56.6c0,31.3,25.4,56.7,56.7,56.7h0l0,0h270.6h2.1 C370.3,215.8,388.4,191.7,388.4,163.8z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "77.7,54.1 108.7,73.4 161.1,94.8 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "83.7,45.8 112.1,64.1 138.7,60.8 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "72.1,62.4 101.1,81.1 107.1,109.8 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 173.7,
    cy: 100.2,
    r: 12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 155,
    cy: 54.1,
    r: 17.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 112.7,
    cy: 129.7,
    r: 20
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 155,
    cy: 54.1,
    r: 11.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 173.7,
    cy: 100.2,
    r: 7.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 112.7,
    cy: 129.7,
    r: 15
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "245.3,217.6 245.1,188.4 237.1,143.9 "
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "237.1,217.2 237.4,190.2 223.7,173.6 "
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "253.3,217.9 253.6,190.3 270.4,174 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M230.3,124.9c4.5-2.8,10.4-1.5,13.2,3c2.8,4.5,1.5,10.4-3,13.2c-4.5,2.8-10.4,1.5-13.2-3 C224.4,133.7,225.8,127.8,230.3,124.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M204.7,153.5c6.5-4.1,15.2-2.2,19.3,4.3c4.1,6.5,2.2,15.2-4.4,19.3c-6.5,4.1-15.2,2.2-19.3-4.3 C196.3,166.3,198.2,157.7,204.7,153.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.9,148.2c7.5-4.7,17.4-2.5,22.1,5c4.7,7.5,2.5,17.4-5,22.1c-7.5,4.7-17.4,2.5-22.1-5 C263.2,162.8,265.4,152.9,272.9,148.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.3,157.6c4.3-2.7,10-1.4,12.7,2.9c2.7,4.3,1.4,10-2.9,12.7c-4.3,2.7-10,1.4-12.7-2.9 C201.7,166,203,160.3,207.3,157.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M232.2,128c2.8-1.8,6.5-0.9,8.3,1.9c1.8,2.8,0.9,6.5-1.9,8.3c-2.8,1.8-6.5,0.9-8.3-1.9 C228.6,133.5,229.4,129.8,232.2,128z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M275,151.6c5.6-3.5,13-1.9,16.6,3.7c3.5,5.6,1.9,13-3.7,16.6c-5.6,3.5-13,1.9-16.6-3.7 C267.8,162.5,269.4,155.1,275,151.6z"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "377.7,137.3 360.8,147.5 337.8,167.6 "
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "380.3,142.2 364.5,151.4 359.7,165.1 "
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "375.1,132.5 359,142 343.7,137.9 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M329.3,178.2c-3.2-1.6-4.5-5.5-2.9-8.7c1.6-3.2,5.5-4.5,8.7-2.9c3.2,1.6,4.5,5.5,2.9,8.7 C336.3,178.5,332.4,179.8,329.3,178.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M354.7,183c-4.7-2.3-6.5-8-4.2-12.7c2.3-4.7,8-6.5,12.7-4.2c4.7,2.3,6.5,8,4.2,12.7 C365,183.5,359.3,185.3,354.7,183z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M327.9,145.4c-5.3-2.7-7.5-9.2-4.8-14.5c2.7-5.3,9.2-7.5,14.5-4.8c5.3,2.7,7.5,9.2,4.8,14.5 C339.7,146,333.2,148.1,327.9,145.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M356.1,180.1c-3.1-1.5-4.3-5.3-2.8-8.3c1.5-3.1,5.3-4.3,8.3-2.8c3.1,1.5,4.3,5.3,2.8,8.3 C362.9,180.4,359.2,181.6,356.1,180.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M330.3,176c-2-1-2.8-3.4-1.8-5.4c1-2,3.4-2.8,5.4-1.8c2,1,2.8,3.4,1.8,5.4C334.8,176.2,332.3,177,330.3,176z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M329.1,143c-4-2-5.6-6.9-3.6-10.9c2-4,6.9-5.6,10.9-3.6c4,2,5.6,6.9,3.6,10.9C338,143.4,333.1,145,329.1,143z"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "20.7,168 35.5,167.6 57.9,163.2 "
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "20.8,163.8 34.5,163.7 42.8,156.6 "
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "20.6,172.1 34.6,171.9 43,180.3 "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M67.5,159.5c1.5,2.2,0.9,5.3-1.4,6.7c-2.2,1.5-5.3,0.9-6.7-1.4c-1.5-2.2-0.9-5.3,1.4-6.7 C63,156.6,66,157.3,67.5,159.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M52.7,146.8c2.2,3.3,1.2,7.7-2,9.8c-3.3,2.2-7.7,1.3-9.8-2c-2.2-3.3-1.3-7.7,2-9.8 C46.2,142.7,50.6,143.6,52.7,146.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M56.1,181.3c2.5,3.7,1.4,8.8-2.3,11.2c-3.7,2.5-8.8,1.4-11.2-2.3c-2.5-3.7-1.4-8.8,2.3-11.2 C48.6,176.5,53.6,177.6,56.1,181.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.7,148.2c1.4,2.1,0.8,5-1.3,6.5c-2.1,1.4-5,0.8-6.5-1.3c-1.4-2.1-0.8-5,1.3-6.5 C46.4,145.4,49.3,146,50.7,148.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.9,160.5c0.9,1.4,0.5,3.3-0.9,4.2c-1.4,0.9-3.3,0.5-4.2-0.9c-0.9-1.4-0.5-3.3,0.9-4.2 C63.1,158.7,65,159.1,65.9,160.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.4,182.4c1.8,2.8,1.1,6.6-1.7,8.4c-2.8,1.8-6.6,1.1-8.4-1.7c-1.8-2.8-1.1-6.6,1.7-8.4 C48.8,178.8,52.6,179.6,54.4,182.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M388.4,163.8c0-31.3-25.4-56.7-56.7-56.7c-4.4,0-8.6,0.5-12.7,1.4c0.7-3.9,1.2-7.9,1.2-12 c0-35.1-28.4-63.5-63.5-63.5c-18.8,0-35.6,8.1-47.2,21.1c-12.2-25.9-38.5-43.8-69-43.8c-42.1,0-76.2,34.1-76.2,76.2 c0,7.2,1,14.1,2.9,20.7c-29.5,2-52.9,26.5-52.9,56.6c0,31.3,25.4,56.7,56.7,56.7h0l0,0h270.6h2.1 C370.3,215.8,388.4,191.7,388.4,163.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.93398d08b00a6f232e873476b0cb7b70.svg";
export { ForwardRef as ReactComponent };